module.exports = __webpack_public_path__ + "assets/stand12w.3555c0cf37c991de8e7569ca18d582d6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/stand12w.png
 ** module id = 183
 ** module chunks = 0
 **/